<template>
  <!-- 筛选标签 -->
  <div class="app-search-tag-body">
    <SearchTag ref="Assets" :tags="tags.assets.name"></SearchTag>
    <SearchTag ref="Engine" :tags="tags.engine.name"></SearchTag>
    <SearchTag ref="ContentType" :tags="tags.contentType.name"></SearchTag>
    <SearchTag ref="OpenType" :tags="tags.openType.name"></SearchTag>
  </div>
</template>

<script>

import SearchTag from "@/views/share/search/SearchTag";

export default {
  name: "SearchEveryThing",
  components: {
    SearchTag
  },
  data() {
    return {
      tags: {
        assets: {
          name: "资产",
          data: [
            {
              tagName: '万物有灵STUDIO'
            },
            {
              tagName: 'HDR'
            },
            {
              tagName: '纹理'
            },
            {
              tagName: '模型'
            },
            {
              tagName: '灯光'
            },
            {
              tagName: '其他'
            }
          ]
        },
        engine: {
          name: "引擎",
          data: [
            {
              tagName: 'EV'
            },
            {
              tagName: 'CYCLES'
            },
            {
              tagName: 'OCTANE'
            }
          ]
        },
        contentType: {
          name: "类型",
          data: [
            {
              tagName: '视频'
            },
            {
              tagName: '文本'
            }
          ]
        },
        openType: {
          name: "开源",
          data: [
            {
              tagName: '官方(可商用)'
            },
            {
              tagName: '上传共享'
            },
            {
              tagName: '委托寄售'
            }
          ]
        }
      }
    }
  }
}
</script>